export default __webpack_public_path__ + "static/media/Management.c94f5fc4.svg";